import { FC } from 'react'
import { Modal } from '../../ui/Modal/Modal'
import './FormModal.scss'
import { LoginForm } from '../Form/LoginForm';
import logoBlack from '../../assets/img/logo-black.png'
import { RegistrationForm } from '../Form/RegistrationForm';
import { FormModalProps } from '../Header/Header';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { toogleAuth } from '../../redux/reducers/authSlice';
import { RootState } from '../../redux/store';

export interface LoginFormProps {
    logRegModal: boolean;
    setLogRegModal: (value: boolean) => void;
  }

export const LogRegModal: FC<FormModalProps> = ({logRegModal, setLogRegModal, successModal, setSuccessModal }) => {

  const auth = useSelector <RootState> ((state)=> state.authSlice)
  const dispatch = useDispatch()

    return (
        <Modal active={logRegModal} setActive={setLogRegModal}>
            <div className='form-container'>
                <img className='form-container__logo' src={logoBlack} alt="logoBlack" />
                {auth ? <LoginForm logRegModal={logRegModal} setLogRegModal={setLogRegModal} /> : <RegistrationForm successModal={successModal} setSuccessModal={setSuccessModal} logRegModal={logRegModal} setLogRegModal={setLogRegModal} />}
                <button className='form-container__btn' onClick={()=>dispatch(toogleAuth())}>{auth ? 'Региcтрация' : 'У меня есть пароль'}</button>
            </div>
        </Modal>
    )
}